export const SET_LOADING = 'SET_LOADING'
export const SET_TASKS = 'SET_TASKS'
export const UPDATE_TASK = 'UPDATE_TASK'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const DELETE_TASK = 'DELETE_TASK'
export const SET_ADMINS = 'SET_ADMINS'
export const SET_CONTACTS = 'SET_CONTACTS'
